import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { OnboardingDialogResult } from '@app/+authenticated/shared/onboarding/onboarding-dialog/onboarding-dialog.model';
import { OnboardingUtils } from '@app/+onboarding/onboarding.utils';
import { KnowledgeBaseArticleLinkModule } from '@app/pipes/knowledge-base-article-link.module';
import { TrackingService } from '@app/services/tracking.service';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonThemePalette } from '@sb/ui/button';
import { DIALOG_DATA, DialogActivationComponent, DialogRef } from '@sb/ui/dialog';

import { OnboardingChapterModule } from '../components/chapter.module';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'optimized-schedule-summary-dialog',
  imports: [DialogActivationComponent, TranslatePipe, NgStyle, OnboardingChapterModule, KnowledgeBaseArticleLinkModule],
  templateUrl: './optimized-schedule-summary-dialog.component.html',
})
export class OptimizedScheduleSummaryDialogComponent implements OnInit {
  private eventData = inject(DIALOG_DATA);
  private dialogRef = inject(DialogRef);
  private trackingService = inject(TrackingService);
  private onboardingUtils = inject(OnboardingUtils);

  ButtonThemePalette = ButtonThemePalette;

  get chapterCTAs() {
    return this.onboardingUtils.chapterCTAs();
  }

  ngOnInit() {
    this.trackingService.event('Onboarding Optimized Scheduling Completed', this.eventData);
  }

  close(result: OnboardingDialogResult) {
    this.dialogRef.close(result);
  }
}
